import { DashboardHeader } from "@/components/shared/dashboard-header"
import { GlobalDefaultsView } from "@/components/alfred/global-defaults-view"

export function AlfredGlobalPage() {
  return (
    <>
      <DashboardHeader />
      <main className="container mx-auto px-4 py-6 space-y-6">
        <div>
          <h1 className="text-2xl font-semibold text-foreground mb-2">Global Defaults</h1>
          <p className="text-sm text-muted-foreground">
            These values are inherited by every client and device that doesn&rsquo;t define its own override.
          </p>
        </div>
        <div data-tour="global-config">
          <GlobalDefaultsView />
        </div>
      </main>
    </>
  )
}
